import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as qs from 'query-string';
import * as Cookies from "universal-cookie";
import { Dispatch, connect } from 'react-redux';
import { IReportState, ReportActionCreators, CenterActionCreators, IApplicationState, AppActionCreators, IBasicCenterListResponse, IAppState } from '@nkr/store/index';
import { ISortBy, ICenterBase, ICenter } from '@nkr/models/index';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import Filter from './filter';
import { IDashVolume } from '@nkr/models/index';
import { IDashVolumeResponse } from '@nkr/store/reports';
import { DashVolume } from './constants';
import { OrganType } from '@nkr/enums/organ-type';

interface VolumePayload {
    includeDash: boolean,
    includeNkr: boolean,
    organType: number,
    centerId: number
}

interface IOwnProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps {
    reports: IReportState
    centerList: ICenter[],
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getBasicCenterList: () => Promise<IBasicCenterListResponse>,
    getDashVolume: (includeNkr: boolean, includeDash: boolean, donationType: number, centerId: number) => Promise<IDashVolumeResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    includeDash: boolean,
    includeNkr: boolean,
    organType: number,
    sortBy: ISortBy[],
    centerList: ICenterBase[],
    summaryVolume: IDashVolume[],
    centerId: number,
    startDate: string,
    endDate: string,
    filteredStartDate: string,
    filteredEndDate: string
}

class DashboardVolume extends React.Component<TProps, IState> {
    readonly state: IState = {
        centerId: 0,
        includeDash: false,
        includeNkr: true,
        organType: 3,
        sortBy: [],
        centerList: [],
        summaryVolume: [],
        startDate: moment().subtract(3, 'months').format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        filteredStartDate: moment().subtract(3, 'months').format("YYYY-MM-DD"),
        filteredEndDate: moment().format("YYYY-MM-DD"),
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let newType = this.props.app.site.organType == OrganType.Kidney ? 3 : 2;
        let parsed = qs.parse(location.search.length > 0 ? location.search : encodeURI("sites[]=dash&organType=" + newType));
        let cookies = new Cookies();

        let organTypeFromCookie = cookies.get('organType');

        if (organTypeFromCookie == null) {
            const current = new Date();
            const nextYear = new Date();

            nextYear.setFullYear(current.getFullYear() + 1);

            cookies.set("organType", newType, { path: "/", expires: nextYear, domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });

            organTypeFromCookie = newType;
        }

        let organTypeForPayload = organTypeFromCookie;

        if (parsed.organType != null) {
            organTypeForPayload = parsed.organType;
        }

        let { centerId: centerNum } = this.props;

        let summaryPayload: VolumePayload = {
            includeDash: parsed.sites != null ? parsed.sites.indexOf('dash') >= 0 : false,
            includeNkr: parsed.sites != null ? parsed.sites.indexOf('nkr') >= 0 : true,
            organType: organTypeForPayload,
            centerId: centerNum !== null || centerNum > 0 ? centerNum : 0
        }

        let { includeNkr, includeDash, organType, centerId } = summaryPayload;

        this.props.showLoading("Getting report data, one moment please...").then(() => {
            Promise.all([
                this.props.getBasicCenterList(),
                this.props.getDashVolume(includeNkr, includeDash, organType, centerId),
            ])
                .then(([centerListResponse, summaryVolumeResponse]) => {
                    let { results: centerList } = centerListResponse.data;

                    let { summaryVolume } = this.state;
                    let { reportResults: summary } = summaryVolumeResponse.data.results;

                    if (summary.length > 0) {
                        summaryVolume = summary;
                    } else {
                        let dashSum = DashVolume
                        dashSum.year = moment().format("YYYY") + ' Total Contacts';
                        summaryVolume = [dashSum];
                    }

                    this.setState({
                        centerList,
                        summaryVolume,
                        organType,
                        includeDash,
                        includeNkr,
                        centerId
                    }, () => {
                        if (this.props.isAdmin == false) {
                            this.setConversionUrl();
                        }

                        this.props.hideLoading();
                    });
                }).catch(() => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                })
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    handleIncludeChange = (property: string) => {
        if (property == 'includeNkr') {
            let includeNkr = !this.state.includeNkr;

            this.setState({
                includeNkr
            });
        }

        if (property == 'includeDash') {
            let includeDash = !this.state.includeDash;

            this.setState({
                includeDash
            });
        }
    }

    handleFilter = () => {
        let { includeNkr, includeDash, organType, centerId } = this.state;

        if (!includeNkr && !includeDash) {
            includeNkr = true;
        }

        this.props.showLoading("Getting report data, one moment please...").then(() => {
            Promise.all([
                this.props.getDashVolume(includeNkr, includeDash, organType, centerId)
            ])
                .then(([summaryVolumeResponse]) => {
                    let { summaryVolume } = this.state;
                    let { reportResults: summary } = summaryVolumeResponse.data.results;

                    if (summary.length > 0) {
                        summaryVolume = summary;
                    } else {
                        let dashSum = DashVolume
                        dashSum.year = moment().format("YYYY") + ' Total Contacts';
                        summaryVolume = [dashSum];
                    }

                    this.setState({
                        summaryVolume,
                        organType,
                        includeDash,
                        includeNkr
                    }, () => {

                        if (this.props.isAdmin == false) {
                            this.setConversionUrl();
                        }

                        this.props.hideLoading();
                    });
                })
                .catch(() => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    handleOrganFilter = (organType: number) => {
        this.setState({
            organType
        }, () => {
            this.handleFilter()
        });
    }

    handleFilterChange = (startDate: string, endDate: string, centerId: number) => {
        this.setState({
            startDate,
            endDate,
            centerId
        });
    }

    setConversionUrl = () => {
        let { organType } = this.state;

        let paramList = [];

        if (organType != null) {
            paramList.push(encodeURI('organType=' + organType));
        }

        let params = paramList.join('&');

        let newUrl = '/center/' + this.props.centerId + '/reports/dash-board/volume?' + params;

        window.history.pushState({}, '', newUrl);
    }

    getOrganTypeTitle = () => {
        if (this.state.organType == 1) {
            return 'Kidney Only';
        }

        if (this.state.organType == 2) {
            return 'Liver Only';
        }

        if (this.state.organType == 3) {
            return 'Liver & Kidney';
        }
    }

    render = () => {
        const organTypeTitle = this.getOrganTypeTitle();

        return (
            <>
                <div style={{ marginBottom: 10, padding: '0px 5px 5px 5px' }}>
                    <div style={{ display: 'flex', justifyContent: 'end', marginBottom: 5 }}>
                        <span>
                            <div>View:&nbsp;
                                <DropdownButton bsStyle='primary' disabled={this.props.app.site.organType == OrganType.Liver} pullRight title={organTypeTitle} id='organType'>
                                    <MenuItem onClick={() => this.handleOrganFilter(2)}>Liver Candidates</MenuItem>
                                    <MenuItem onClick={() => this.handleOrganFilter(1)}>Kidney Candidates</MenuItem>
                                    <MenuItem onClick={() => this.handleOrganFilter(3)}>Liver &amp; Kidney Candidates</MenuItem>
                                </DropdownButton>
                            </div>
                        </span>
                    </div>

                    <Filter
                        isAdmin={this.props.isAdmin}
                        centerId={this.state.centerId}
                        includeDash={this.state.includeDash}
                        includeNkr={this.state.includeNkr}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        centerList={this.state.centerList}
                        onChange={this.handleIncludeChange}
                        onFilterChange={this.handleFilterChange}
                        onFilter={this.handleFilter}
                    />

                    {/* //Volume */}
                    <div className="row">
                        <div className='col-xs-12'>
                            <table className='table table-bordered table-striped table-nkr-styled'>
                                <thead>
                                    <tr style={{ backgroundColor: '#f0f0f0' }}>
                                        <th style={{ textAlign: 'center' }}>Volume</th>
                                        <th style={{ textAlign: 'center' }}>Jan</th>
                                        <th style={{ textAlign: 'center' }}>Feb</th>
                                        <th style={{ textAlign: 'center' }}>Mar</th>
                                        <th style={{ textAlign: 'center' }}>Apr</th>
                                        <th style={{ textAlign: 'center' }}>May</th>
                                        <th style={{ textAlign: 'center' }}>Jun</th>
                                        <th style={{ textAlign: 'center' }}>Jul</th>
                                        <th style={{ textAlign: 'center' }}>Aug</th>
                                        <th style={{ textAlign: 'center' }}>Sep</th>
                                        <th style={{ textAlign: 'center' }}>Oct</th>
                                        <th style={{ textAlign: 'center' }}>Nov</th>
                                        <th style={{ textAlign: 'center' }}>Dec</th>
                                        <th style={{ textAlign: 'center' }}>TOTAL</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.summaryVolume.map((summaryVolume) =>
                                        <tr>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.year}</td>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.janCount} </td>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.febCount} </td>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.marCount} </td>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.aprCount} </td>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.mayCount} </td>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.junCount} </td>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.julCount} </td>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.augCount} </td>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.sepCount}</td>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.octCount} </td>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.novCount} </td>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.decCount} </td>
                                            <td style={{ textAlign: 'center' }}>{summaryVolume.total} </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        reports: appState.reports,
        centerList: appState.centers.list,
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getBasicCenterList: () => {
            return dispatch(CenterActionCreators.getBasicCenterList(false));
        },
        getDashVolume: (includeNkr: boolean, includeDash: boolean, donationType: number, centerId: number, doGroupByCenter: boolean = false, isYearly: boolean = false) => {
            return dispatch(ReportActionCreators.getDashVolume(includeNkr, includeDash, donationType, centerId, doGroupByCenter, isYearly));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(DashboardVolume);